import { MouseEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from '@/components/button';
import Control from '@/components/control';
import { QuestionnaireItemProps } from '@/components/questionnaire-item';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { cn } from '@/utils/helper';
import v1 from '@/components/questionnaire-item/questionnaire-item-1.module.css';
import v2 from '@/components/questionnaire-item/questionnaire-item-2.module.css';

const QuestionnaireItem = (props: QuestionnaireItemProps) => {
  const { t } = useTranslation();
  const titleRef = useRef(null);
  const childrenRef = useRef(null);
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);

  const onHeadClickHandler = (e: MouseEvent<HTMLDivElement>): void => {
    if (e.target === titleRef.current && !props.isActive) {
      props.onHeadClick(props.index);
    }
  };

  const onMainClickHandler = (e: MouseEvent<HTMLDivElement>): void => {
    if (e.currentTarget === childrenRef.current && !props.isActive) {
      props.onMainClick(props.index, props.type);
    }
  };

  const onNextHandler = () => {
    props.onNextClick();
  };

  return (
    <div
      className={clsx(cn(v1.Item, v2.Item), {
        [cn(v1.Last, v2.Last)]: props.isLast,
        [cn(v1.Active, v2.Active)]: props.isActive,
        [cn(v1.Clickable, v2.Clickable)]: props.isClickable,
      })}
      onClick={onHeadClickHandler}
    >
      <h6 className={cn(v1.Title, v2.Title)} ref={titleRef}>
        {props.title()}
      </h6>
      <div className={cn(v1.Child, v2.Child)} ref={childrenRef} onClick={onMainClickHandler}>
        {props.children}
      </div>
      {props.isRequiredShown ? (
        <div className={cn(v1.Required, v2.Required)}>
          {t(props.requiredMessage) || t('Dieses Feld ist erforderlich.')}
        </div>
      ) : null}
      {props.isActive && cssVersion === 1 ? (
        <div className={v1.Wrapper}>
          <Button color='primary' className={v1.GoNext} onClick={onNextHandler}>
            {t('Weiter')}
          </Button>
          <span className={v1.NextText} dangerouslySetInnerHTML={{ __html: t('oder <i>EINGABE</i> drücken') }} />
        </div>
      ) : null}
      {props.isActive && cssVersion === 2 ? (
        <Control.Button color='next' size='md' type='button' onClick={onNextHandler}>
          {t('Weiter')}
        </Control.Button>
      ) : null}
    </div>
  );
};

export default QuestionnaireItem;
